module.exports = __webpack_public_path__ + "static/media/near_spacegrn.25835634.png";